<template>
    <v-card>
        <v-layout v-if="loading">
            <v-progress-linear color="primary" indeterminate></v-progress-linear>
        </v-layout>
        <v-layout v-if="!loading && availableStores.length <= 0">
            <v-layout>
                    <v-flex xs12>
                        <error-alert content="You do not have access to any stores" display="true"></error-alert>
                    </v-flex>
                </v-layout>
        </v-layout>
        <v-layout v-if="!storeSelected && !loading && availableStores.length > 0">
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Please select a store</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="store-selection">
                    <v-flex v-for="store in availableStores" :key="store.ID" xs12 sm6 md3 lg2>
                        <v-btn
                            color="accent"
                            block
                            @click="selectStore(store)"
                        >
                            {{store.Name}}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout wrap v-if="storeSelected && !loading">
            <v-flex xs12>
                <v-layout>
                    <v-flex xs12>
                        <h1 class="text-xs-center">Suppliers for {{selectedStore.Name}}</h1>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions">
                    <v-flex xs12 sm6 md4 offset-md2 xl2 offset-xl4>
                        <v-btn
                            v-if="availableStores.length > 1"
                            color="navigation"
                            block
                            @click="clearSelectedStore()"
                        >
                            Back to Store Select
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn
                            color="accent"
                            block
                            @click="showCopy()"
                        >
                            Copy From Store
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                        <v-btn
                            color="success"
                            block
                            @click="saveSupplierChanges()"
                        >
                            Save Changes
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions" v-if="saveValidationErrors.length > 0">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4 v-for="(errorMessage, index) in saveValidationErrors" :key="index">
                        <error-alert :content="errorMessage" :display="errorMessage"></error-alert>
                    </v-flex>
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4 v-if="validationErrorProductIDs.length > 0">
                        <v-checkbox
                            v-model="filterByValidationProductIDs"
                            label="Filter By Errors">
                        </v-checkbox>                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions" v-if="saveError">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                        <error-alert :content="saveError" display="true"></error-alert>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12 v-if="saveValidationErrors.length > 0">
                <v-layout row pb-1>
                    <v-flex xs12 sm2 offset-sm2>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12 v-if="!filterByValidationProductIDs">
                <v-layout row pb-1>
                    <v-flex xs12 sm2 offset-sm2>
                        <v-autocomplete
                            :items="availableCategories"
                            item-text="Name"
                            item-value="ID"
                            v-model="search.categoryIDs"
                            multiple
                            clearable
                            label="Categories"
                            hint="Categories"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-autocomplete
                            :items="availableProducts"
                            item-text="Name"
                            item-value="ID"
                            v-model="search.productIDs"
                            multiple
                            clearable
                            label="Products"
                            hint="Products"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm2 offset-sm1>
                        <v-autocomplete
                            :items="availableSuppliers"
                            item-text="Name"
                            item-value="ID"
                            v-model="search.supplierIDs"
                            multiple
                            clearable
                            label="Suppliers"
                            hint="Suppliers"
                        ></v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-flex xs12>
                <v-layout wrap class="product-list">
                    <v-flex class="category-container" xs12 v-for="(category, categoryIndex) in storeSuppliersByCategory" :key="category.ID">
                        <v-layout class="category-title" wrap>
                            <v-flex xs12>
                                <h3>{{category.CategoryName}}</h3>
                            </v-flex>
                        </v-layout>
                        <v-layout :class="makeProductClassNames(product, productIndex)" wrap v-for="(product, productIndex) in category.products" :key="product.ID">
                            <v-flex xs4 lg3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <h4>{{product.Name}}</h4>
                                    </v-flex>
                                    <v-flex xs12 lg6>
                                        <v-btn block color="success" @click="addSupplier(categoryIndex, productIndex)">
                                            <span class="hidden-xs-only">Add Supplier</span>
                                            <span class="hidden-sm-and-up">Add</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs8 lg9>
                                <v-layout wrap v-for="(supplier, supplierIndex) in product.suppliers" :key="supplierIndex"><!-- this implementation limits us to a maximum of 10 different suppliers for a product -->
                                    <v-flex xs12 lg6>
                                        <v-autocomplete
                                            :items="suppliers"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="supplier.SupplierID"
                                            :label="'Supplier ' + (supplierIndex + 1)"
                                            :hint="'Supplier ' + (supplierIndex + 1)"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm6 lg3>
                                        <v-text-field
                                            clearable
                                            mask="#########"
                                            v-model="supplier.Quantity"
                                            :rules="[rules.numericOrEmpty]"
                                            label="Quantity">
                                        </v-text-field>
                                    </v-flex>
                                    <v-flex xs12 sm6 lg3>
                                        <v-btn block color="error" @click="removeSupplier(categoryIndex, productIndex, supplierIndex)">
                                            <span class="hidden-sm-and-down">Remove Supplier</span>
                                            <span class="hidden-md-and-up">Remove</span>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <div class="v-datatable theme--light">
                    <div class="v-datatable__actions">
                        <div class="shrink v-datatable__actions__select">
                            <span class="pr-2">Rows per page:</span>
                            <v-select hide-details
                                :items="availablePageSizes"
                                :value="pagination.pageSize"
                                @input="updatePageSize">
                            </v-select>
                        </div>
                        <div class="v-datatable__actions__range-controls">
                            <span v-if="paginationDescription" class="v-datatable__actions__pagination">{{ paginationDescription }}</span>
                            <span v-else="paginationDescription" class="v-datatable__actions__pagination">-</span>
                            <v-btn :disabled="!canGoBack" icon @click="goBack"><v-icon>chevron_left</v-icon></v-btn>
                            <v-btn :disabled="!canGoForward" icon @click="goForward"><v-icon>chevron_right</v-icon></v-btn>
                        </div>
                    </div>
                </div>
            </v-flex>

            <v-flex xs12>
                <v-layout wrap class="grid-actions">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                        <v-btn
                            color="success"
                            block
                            @click="saveSupplierChanges()"
                        >
                            Save Changes
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions" v-if="saveValidationErrors.length > 0">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4 v-for="(errorMessage, index) in saveValidationErrors" :key="index">
                        <error-alert :content="errorMessage" :display="errorMessage"></error-alert>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions" v-if="saveError">
                    <v-flex xs12 md8 offset-md2 xl4 offset-xl4>
                        <error-alert :content="saveError" display="true"></error-alert>
                    </v-flex>
                </v-layout>
                <v-layout wrap class="grid-actions">
                    <v-flex xs12 sm6 md4 offset-md2 xl2 offset-xl4>
                        <v-btn
                            v-if="availableStores.length > 1"
                            color="navigation"
                            block
                            @click="clearSelectedStore()"
                        >
                            Back to Store Select
                        </v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 md4 xl2>
                        <v-btn
                            color="accent"
                            block
                            @click="showCopy()"
                        >
                            Copy From Store
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>

            <v-dialog v-model="showCopyDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark :disabled="savingCopy" @click="cancelCopy">
                            <v-icon large>close</v-icon>
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-toolbar-title>Copy Suppliers from selected store to {{selectedStore.Name}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-form v-model="copyValid">
                        <v-layout class="dialog-content">
                            <v-flex xs12 md6 offset-md3>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-autocomplete
                                            :items="availableStores.filter(s => s.ID !== selectedStore.ID)"
                                            item-text="Name"
                                            item-value="ID"
                                            v-model="copyStoreID"
                                            label="Copy From"
                                            :rules="[rules.selectIDRequired]"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-checkbox
                                            v-model="copyStoreConfirm"
                                            label="I confirm that I want to copy the suppliers, including dates, from the selected store. All existing suppliers for the target store will be removed."
                                            :rules="[rules.checkboxRequired]"
                                        ></v-checkbox>
                                    </v-flex>
                                </v-layout>
                                <v-layout wrap class="dialog-action-buttons">
                                    <v-flex xs12 sm6>
                                        <v-btn block color="error" :disabled="savingCopy" @click="cancelCopy">Cancel</v-btn>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <v-btn block color="success" :disabled="!copyValid" :loading="savingCopy" @click="saveCopy()">Save</v-btn>
                                    </v-flex>
                                    <v-flex xs12>
                                        <error-alert :content="saveCopyError" :display="saveCopyError"></error-alert>
                                    </v-flex>
                                </v-layout>                            
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-card>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import formatters from "../../helpers/formatters";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';

export default {
    components: {
        ErrorAlert
    },
    props: [
        
    ],
    data() {
        return {
            showCopyDialog: false,
            copyStoreID: null,
            copyStoreConfirm: false,
            copyValid: false,
            saveValidationErrors: [],
            validationErrorProductIDs: [],
            filterByValidationProductIDs: false,
            rules: validationRules.rules,
            availablePageSizes: [
                20, 50, 100
            ],
            pagination: {
                startPage: 0,
                pageSize: 20
            },
            search: {
                categoryIDs: [],
                productIDs: [],
                supplierIDs: []
            }
        };
    },
    watch: {
        search: {
            handler(){
                this.pagination.startPage = 0;
            },
            deep: true
        }
    },
    computed: {
        availableStores() {
            // return actual store objects, so that we have the appropriate data required for the page
            return this.$store.state.storeStore.stores.filter(s => s.Active && auth.hasAccessToStore(s.ID));
        },
        selectedStore() {
            return this.$store.state.storeSupplierStore.store;
        },
        storeSelected() {
            return this.$store.state.storeSupplierStore.store && this.$store.state.storeSupplierStore.store.ID && this.$store.state.storeSupplierStore.store.ID > 0;
        },
        loading() {
            return this.saving || this.$store.state.productStore.loading || this.$store.state.categoryStore.loading || this.$store.state.storeSupplierStore.loading || this.$store.state.storeStore.loading || this.$store.state.supplierStore.loading;
        },
        loadError() {
            return this.$store.state.storeSupplierStore.loadError;
        },
        saving() {
            return this.$store.state.storeSupplierStore.saving;
        },
        saveError() {
            return this.$store.state.storeSupplierStore.saveError;
        },
        savingCopy() {
            return this.$store.state.storeSupplierStore.savingCopy;
        },
        saveCopyError() {
            return this.$store.state.storeSupplierStore.saveCopyError;
        },
        canGoBack(){
            return this.pagination.startPage > 0;
        },
        canGoForward(){
            if(!this.$store.state.productStore.products){
                return false;
            }

            if((this.pagination.startPage + 1) * this.pagination.pageSize > this.filteredProducts.length){
                return false;
            }

            return true;
        },
        activeProducts(){
            if(!this.$store.state.productStore.products || this.$store.state.productStore.products.length <= 0){
                return [];
            }

            return this.$store.state.productStore.products
                .filter(p => p.Active)
                .sort((a, b) => {
                    if(a.CategorySortOrder < b.CategorySortOrder){
                        return -1;
                    }

                    if(a.CategorySortOrder > b.CategorySortOrder){
                        return 1;
                    }

                    return a.CategoryName.toUpperCase().localeCompare(b.CategoryName.toUpperCase());
                });
        },
        availableCategories(){
            if(!this.$store.state.categoryStore.categories){
                return [];
            }

            return this.$store.state.categoryStore.categories;
        },
        availableProducts(){
            return this.activeProducts;
        },
        availableSuppliers(){
            if(!this.$store.state.supplierStore.suppliers){
                return [];
            }

            return this.$store.state.supplierStore.suppliers;
        },
        filteredProducts(){
            return this.activeProducts.filter(x => {
                if(this.filterByValidationProductIDs){
                    if(this.validationErrorProductIDs.findIndex(y => y == x.ID) < 0){
                        return false;
                    }

                    return true;
                }

                if(this.search.categoryIDs.length > 0){
                    if(this.search.categoryIDs.indexOf(x.CategoryID) < 0){
                        return false;
                    }
                }

                if(this.search.productIDs.length > 0){
                    if(this.search.productIDs.indexOf(x.ID) < 0){
                        return false;
                    }
                }

                if(this.search.supplierIDs.length > 0){
                    if(!this.$store.state.storeSupplierStore.storeSuppliers || this.$store.state.storeSupplierStore.storeSuppliers.length == 0){
                        return false;
                    }

                    let productSupplierData = this.$store.state.storeSupplierStore.storeSuppliers[x.ID];
                    if(!productSupplierData){
                        return false;
                    }

                    let productSuppliers = productSupplierData.suppliers;
                    if(!productSuppliers.some(y => this.search.supplierIDs.indexOf(y.SupplierID) >= 0)){
                        return false;
                    }
                }

                return true;
            });
        },
        paginatedProducts(){
            return this.filteredProducts.slice(
                (this.pagination.startPage) * this.pagination.pageSize,
                (this.pagination.startPage + 1) * this.pagination.pageSize
            );
        },
        paginationDescription(){
            if(this.paginatedProducts.length == 0){
                return null;
            }

            let startItemNumber = (this.pagination.startPage * this.pagination.pageSize) + 1;
            let endItemNumber = (this.pagination.startPage + 1) * this.pagination.pageSize;
            let totalItemNumber = this.filteredProducts.length;
            if(endItemNumber > totalItemNumber){
                endItemNumber = totalItemNumber;
            }

            return `${startItemNumber}-${endItemNumber} of ${totalItemNumber}`;
        },
        storeSuppliersByCategory() {
            let data = {};

            if (   !this.$store.state.categoryStore.categories || this.$store.state.categoryStore.categories.length <=0
                || !this.$store.state.productStore.products || this.$store.state.productStore.products.length <= 0
                || !this.$store.state.storeSupplierStore.storeSuppliers || this.$store.state.storeSupplierStore.storeSuppliers.length <=0
                || !this.$store.state.supplierStore.suppliers || this.$store.state.supplierStore.suppliers.length <=0) {
                // some of the required data not available
                return data;
            }

            let sortedCategories = this.$store.state.categoryStore.categories.sort(function(a, b) {
                return a.Name.toUpperCase().localeCompare(b.Name.toUpperCase());
            });

            // start by listing all of the categories
            for (let c=0; c<sortedCategories.length; c++) {
                let category = sortedCategories[c];

                data[category.ID] = {
                    CategoryName: category.Name,
                    CategoryID: category.ID,
                    SortOrder: category.SortOrder
                };
                data[category.ID].products = [];
            }

            // now add all the products to this data
            let products = this.paginatedProducts;

            for (let p=0; p<products.length; p++) {
                let product = products[p];

                // find the supplier data for this product (for this store)
                let suppliersForProduct = [];
                if (this.$store.state.storeSupplierStore.storeSuppliers[product.ID]) {
                    suppliersForProduct = this.$store.state.storeSupplierStore.storeSuppliers[product.ID].suppliers;
                }

                data[product.CategoryID].products.push({
                    ID: product.ID,
                    Name: product.Name,
                    suppliers: suppliersForProduct
                });
            }

            let sortedData = [];

            // sort the products into the correct order, and sort the categories into order as well
            // also remove any categories with no products
            for (let c=0; c<sortedCategories.length; c++) {
                let category = sortedCategories[c];

                data[category.ID].products = data[category.ID].products.sort(function(a, b) {
                    return a.Name.toUpperCase().localeCompare(b.Name.toUpperCase());
                });

                if (data[category.ID].products.length > 0) {
                    sortedData.push(data[category.ID]);
                }
            }
            
            //sort categories by sort order
            sortedData.sort((a,b) => {
                if(a.SortOrder > b.SortOrder) {
                    return 1
                } else if(a.SortOrder < b.SortOrder) {
                    return -1
                } else {
                    return 0
                }
            })
            return sortedData;
        },
        suppliers() {
            return this.$store.state.supplierStore.suppliers.filter(s => s.Active);
        },
        categoriesSorted() {
            return this.$store.state.categoryStore.categories.sort(function(a, b) {
                return a.Name.toUpperCase().localeCompare(b.Name.toUpperCase());
            });
        }
    },
    methods: {
        goBack(){
            if(!this.canGoBack){
                return;
            }

            this.pagination.startPage--;
        },
        goForward(){
            if(!this.canGoForward){
                return;
            }

            this.pagination.startPage++;
        },
        updatePageSize(newPageSize){
            this.pagination.pageSize = newPageSize;
            this.pagination.startPage = 0;
        },
        clearData() {
            this.$store.dispatch("storeSupplierStore/clearSaveError");
            this.$store.dispatch("storeSupplierStore/clearSaveCopyError");
            this.saveValidationErrors = [];
            this.validationErrorProductIDs = [];
            this.filterByValidationProductIDs = false;
        },
        addSupplier(categoryIndex, productIndex) {
            let product = this.storeSuppliersByCategory[categoryIndex].products[productIndex];

            this.$store.dispatch("storeSupplierStore/addSupplierEntry", product.ID);
        },
        removeSupplier(categoryIndex, productIndex, supplierIndex) {
            let product = this.storeSuppliersByCategory[categoryIndex].products[productIndex];

            product.suppliers.splice(supplierIndex, 1);
        },
        makeProductClassNames(product, index) {
            let className = (index % 2) ? "even" : "odd";
            let potentialErrorClass = this.validationErrorProductIDs.includes("" + product.ID) ? " validation-error" : "";

            return "product-container " + className + potentialErrorClass;
        },
        selectStore(store) {
            this.clearData();

            this.$store.dispatch("storeSupplierStore/loadStoreSuppliers", {
                storeID: store.ID,
                formatSupplierData: true
            });

            this.$store.dispatch("storeSupplierStore/setSelectedStore", store);
        },
        loadStores() {
            this.$store.dispatch("storeStore/loadStores");
        },
        loadSuppliers() {
            this.$store.dispatch("supplierStore/loadSuppliers");
        },
        loadProducts() {
            this.$store.dispatch("productStore/loadProducts");
        },
        loadCategories() {
            this.$store.dispatch("categoryStore/loadCategories");
        },
        clearSelectedStore() {
            this.pagination.startPage = 0;
            
            this.$store.dispatch("storeSupplierStore/clearSaveError");
            this.$store.dispatch("storeSupplierStore/clearSaveCopyError");

            this.$store.dispatch("storeSupplierStore/setSelectedStore", null);
        },
        showCopy() {
            this.$store.dispatch("storeSupplierStore/clearSaveCopyError");
            this.copyStoreID = null;
            this.copyStoreConfirm = false;
            this.showCopyDialog = true;
        },
        cancelCopy() {
            this.showCopyDialog = false;
            this.copyStoreID = null;
            this.copyStoreConfirm = false;
        },
        saveCopy() {
            this.$store.dispatch("storeSupplierStore/clearSaveCopyError");

            let that = this;

            let data = {
                fromStoreID: this.copyStoreID,
                toStoreID: this.selectedStore.ID
            };

            this.$store.dispatch("storeSupplierStore/saveCopy", {
                data,
                formatSupplierData: true,
                finally: function() {
                    if (that.$store.state.storeSupplierStore.saveCopyError) {
                        // do not close the dialog
                        // display the error
                    }
                    else {
                        // close the dialog
                        that.cancelCopy();
                    }
                }
            });
        },
        saveSupplierChanges() {
            if (this.validateData()) {
                this.$store.dispatch("storeSupplierStore/saveStoreSuppliers", {
                    formatSupplierData: true
                });
                this.$store.dispatch("storeSupplierStore/setSelectedStore", null);
            }
        },
        validateData() {
            this.saveValidationErrors = [];
            this.validationErrorProductIDs = [];

            let showErrorMessageNonPositiveQuantity = false;
            let showErrorMessageRepeatedSupplier = false;

            for (let productID in this.$store.state.storeSupplierStore.storeSuppliers) {
                if (this.$store.state.storeSupplierStore.storeSuppliers.hasOwnProperty(productID)) {
                    let suppliers = this.$store.state.storeSupplierStore.storeSuppliers[productID].suppliers;

                    let supplierIDs = [];

                    // loop through all suppliers
                    for (let i=0; i<suppliers.length; i++) {
                        let supplier = suppliers[i];
                        
                        if (supplier.SupplierID && supplier.SupplierID > 0) {
                            // this is an actual entry (ignore the blank ones)

                            if (supplierIDs.includes(supplier.SupplierID)) {
                                // we've already got this supplier ID in the list - so there is a duplicate
                                showErrorMessageRepeatedSupplier = true;
                                this.validationErrorProductIDs.push(productID);
                            }
                            else {
                                supplierIDs.push(supplier.SupplierID);
                            }
                        }
                    }
                }
            }

            if (showErrorMessageRepeatedSupplier) {
                this.saveValidationErrors.push("Cannot have the same supplier more than once for a single product");
            }

            if (this.saveValidationErrors.length > 0) {
                if(this.validationErrorProductIDs.length > 0){
                    this.filterByValidationProductIDs = true;
                } else {
                    this.filterByValidationProductIDs = false;
                }

                return false;
            }

            return true;
        }
    },
    created() {
        // https://jira.comunet.com.au/browse/FC1-211
        // if we are returning to this page from somewhere else, we do *not* want the data loaded the first time to be displayed
        // this will cause us to save old data for the store's suppliers
        // eg. when suppliers are updated on the Assign to all Stores page, those changes need to be reflected when we come back to this page
        this.$store.dispatch("storeSupplierStore/setSelectedStore", null);

        this.loadStores();
        this.loadSuppliers();
        this.loadProducts();
        this.loadCategories();
    }
};
</script>

<style>
    .store-selection .flex, .confirm-dialog .flex, .grid-actions .flex {
        padding-left: 5px;
        padding-right: 5px;
    }

    .category-container {
        border: 1px solid #bcbcbc;
        padding: 5px;
        margin-bottom: 5px;
    }

    .product-container .flex {
        padding: 5px;
    }

    .product-container.even {
        background-color: #f2f2f2;
    }

    .product-container.validation-error {
        border: 5px solid #e57373;
    }
</style>
